const initialState = {
  showScannerView: false,
  scannerItemType: 'food',
  scannerIsRecipe: false,

  showRecipeView: false,
  currentRecipe: {},
  recipeItemIndex: '',

  // For timeline edit screen and edit-adding from recipe favorites/add item snackbar
  editScreenCloseMod: '',
  showEditScreenTimeline: false,
  showEditScreenAddItem: false,
  editScreenItem: {},
}

export default function TrackerViewReducer(state = initialState, action) {
  switch (action.type) {
    case 'SHOW_SCANNER_VIEW': {
      state = {...state, ...action.payload};
      break
    }
    case 'CLOSE_SCANNER_VIEW': {
      state = {...state, ...action.payload};
      break
    }
    case 'SHOW_RECIPE_VIEW': {
      state = {...state, ...action.payload};
      break
    }
    case 'CLOSE_RECIPE_VIEW': {
      state = {...state, ...action.payload};
      break
    }
    case 'UPDATE_RECIPE': {
      state = {...state, ...action.payload};
      break
    }
    case 'UPDATE_EDIT_SCREEN_ITEM': {
      state = {...state, ...action.payload};
      break
    }
    case 'UPDATE_SHOW_EDIT_SCREEN_TIMELINE': {
      state = {...state, ...action.payload};
      break
    }
    case 'UPDATE_SHOW_EDIT_SCREEN_ADD_ITEM': {
      state = {...state, ...action.payload};
      break
    }
    case 'UPDATE_EDIT_SCREEN_CLOSE_MOD': {
      state = {...state, ...action.payload};
      break
    }
    default:
      break
  }
  return state
}
